import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-10 py-8 sm:py-10 md:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 md:gap-10 lg:gap-12">
          {/* Quick Links Section */}
          <div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 sm:mb-5">Quick Links</h3>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base md:text-lg">
              <li>
                <Link to="/"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/materials"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  Materials
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information Section */}
          <div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 sm:mb-5">Contact Us</h3>
            <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base md:text-lg">
              <li>
                <span>Email: </span>
                <a
                  href="mailto:revawkr@gmail.com"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  revawkr@gmail.com
                </a>
              </li>
              <li>
                <span>Phone: </span>
                <a
                  href="tel:+919426788499"
                  className="hover:text-[#e0990b] transition-colors"
                >
                  +91-94267 88499
                </a>
              </li>
              <li>
                <span>Address: </span>
                <span>Reva Industries, NH-27, Lalpar,<br /> 
                      Wankaner, Morbi, Gujarat 363621<br />
                      India.
                </span>
              </li>
            </ul>
          </div>

          {/* Social Media Links and Google Map Section */}
          <div>
            <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 sm:mb-5">Follow Us</h3>
            <div className="flex space-x-3 sm:space-x-4 md:space-x-5 mb-6 sm:mb-8">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl sm:text-3xl md:text-4xl hover:text-[#e0990b] transition-colors"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/reva.industries/profilecard/?igsh=MWowNjNjdmc4cDU0MQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl sm:text-3xl md:text-4xl hover:text-[#e0990b] transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl sm:text-3xl md:text-4xl hover:text-[#e0990b] transition-colors"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
            </div>
            <div className="mt-4 sm:mt-5">
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 sm:mb-5">Our Location</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3681.356054468005!2d70.9845625!3d22.5759375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959bde1665fc0e9%3A0x4a3b8ea99281109c!2sREVA%20INDUSTRIES%2C%20NH-27%2C%20Lalpar%2C%20Wankaner%2C%20Morbi%2C%20Gujarat%20363621%2C%20India!5e0!3m2!1sen!2sin!4v1730282600000!5m2!1sen!2sin"
                className="w-full h-40 sm:h-48 md:h-56 lg:h-64 rounded-lg border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="ReVa Industries Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 p-4 sm:p-5 md:p-6 text-center text-gray-400 text-sm sm:text-base md:text-lg">
        <p>© 2025 ReVa Industries. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;